<template>
	<v-dialog v-model="showDialog" width="500" min-height="400" persistent>
		<v-card>
			<v-card-title> Add Merge Field</v-card-title>
			<v-divider />
			<v-card-text>
				<v-form ref="field">
					<v-select
						v-model="selectedField"
						:rules="[rules.required]"
						label="Field"
						:items="
							items.sort((a, b) => (a.Label > b.Label ? 1 : -1))
						"
						item-text="Label"
						item-value="Id"
					>
						<template v-slot:item="data">
							<v-list-item-content>
								<v-list-item-title>{{
									data.item.Label
								}}</v-list-item-title>
							</v-list-item-content>
						</template>
					</v-select>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn @click.stop="onSave" color="primary">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { MergeConditionsActions } from '../../../store/actions';
export default {
	name: 'MergeConditionsFieldModal',
	props: {
		showDialog: Boolean,
		items: Array,
		entityId: String,
	},
	data() {
		return {
			loading: false,
			selectedField: null,
			rules: {
				required: (value) => !!value || 'Field is required',
			},
		};
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			let item = {
				EntityId: this.entityId,
				GridViewFieldId: this.selectedField,
			};
			if (this.$refs.field.validate()) {
				this.$store
					.dispatch(
						MergeConditionsActions.INSERT_MERGE_CONDITION_FIELD,
						item
					)
					.then(() => this.$emit('close'));
			}
		},
	},
};
</script>
